export default "__VITE_ASSET__i5nk$tPb__"